<template>
  <div class="mb-14">
    <v-card elevation="2" class="parent-card">
      <v-card-text class="pa-5">
        <!-- <v-col cols="12" sm="12" md="12"> </v-col> -->
        <div class="d-flex justify-space-between">
          <h2>{{ name }} 👋</h2>
          <v-spacer></v-spacer>
          <div @click="routeToGamification">
            <gamificationCoinVue
              :amount="coins"
              :isProfilePage="true"
              class="mt-n2"
            />
          </div>
        </div>

        <div>
          Check out the daily tasks to earn more covesto coins and earn
          discounts
        </div>
        <div v-for="item in todoList" :key="item.index">
          <v-card
            class="pa-3 mt-4"
            v-if="item.is_active"
            @click="handleCardClick(item.key)"
          >
            <div class="d-flex">
              <div>
                <v-img class="img" :src="item.file"></v-img>
              </div>
              <div class="ml-2 my-auto text">
                <div>{{ item.key }}</div>
              </div>
            </div>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
    <StreakModal />
    <LockTradeModal />
    <JoiningBonusModal />
  </div>
</template>

<script>
import gamificationCoinVue from "@/components/gamification/gamificationCoin.vue";
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import StreakModal from "@/components/gamification/streakModal.vue";
import LockTradeModal from "@/components/gamification/lockTradeModal.vue";
import JoiningBonusModal from "@/components/gamification/joiningBonusModal.vue";
export default {
  name: "GamificationSection",
  components: {
    gamificationCoinVue,
    StreakModal,
    LockTradeModal,
    JoiningBonusModal,
  },
  data() {
    return {
      deefault_user: require("@/assets/images/premium_badge.svg"),
      todoList: [],
      name: "",
      coins: "",
    };
  },
  mounted() {
    this.getCoinData();
  },
  methods: {
    routeToGamification() {
      this.$router.push({ name: "Gamification" });
    },
    getCoinData() {
      const onSuccess = (res) => {
        this.name = res.data.data.name;
        this.coins = res.data.data.coins;
        this.todoList = res.data.data.todos_list;
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GAMIFICATION_DATA, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    handleCardClick(key) {
      switch (key) {
        case "Exclusive one-time rewards for new users":
          this.taskThreeAction();
          break;
        case "Finish all of day’s tasks to receive a bonus":
          this.taskTwoAction();
          break;
        case "Keep up a daily task streak to earn discounts":
          this.taskOneAction();
          break;
        default:
          this.defaultAction();
          break;
      }
    },
    taskOneAction() {
      this.$store.commit("gamification/TOGGLE_STREAK_MODAL", { show: true });
    },
    taskTwoAction() {
      this.$store.commit("gamification/TOGGLE_LOCK_TRADE_MODAL", {
        show: true,
      });
    },
    taskThreeAction() {
      this.$store.commit("gamification/TOGGLE_JOINING_BONUS_MODAL", {
        show: true,
      });
    },
    defaultAction() {
      console.log("Default action triggered");
    },
  },
};
</script>

<style scoped lang="scss">
.parent-card {
  border-radius: 12px;
  background-image: url("~@/assets/images/trending/gamificationBG.png");
  background-size: cover;
  background-origin: border-box; /* Ensure background includes border */

  border: 2px solid #e5d18e; /* Set border color to transparent 
  border-image: linear-gradient(102.02deg, #d6c58d, #ffe68e, #dcc05c);
  border-image-slice: 1;*/
}

.img {
  height: 28px;
  width: 28px;
}
.text {
  font-family: Avenir;
  font-size: 15px;
  font-weight: 500;
  line-height: 20.49px;
  color: #333333;
}

@media only screen and (max-width: 600px) {
  .parent-card {
    border-radius: 12px;
    background-image: url("~@/assets/images/trending/gamificationBGmobile.png");
    background-size: cover;
    background-origin: border-box; /* Ensure background includes border */

    border: 2px solid #e5d18e;
  }
  .text {
    font-family: Avenir;
    font-size: 12px;
    font-weight: 500;
    line-height: 16.39px;
    color: #333333;
  }
  .img {
    height: 16px;
    width: 16px;
  }
}
</style>
